import { render, staticRenderFns } from "./companySettings.vue?vue&type=template&id=1ad3edd2&"
import script from "./companySettings.vue?vue&type=script&lang=js&"
export * from "./companySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports